import React from 'react';

import { Form } from 'react-bootstrap';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FieldErrors, useForm } from 'react-hook-form';

import { ICreateWorkerFormData } from 'forms/worker';
import { ICroppedImage } from 'models/profile-picture/ICroppedImage';

interface IUploadProfileImageButton {
    register: ReturnType<typeof useForm>['register'];
    errors: FieldErrors<ICreateWorkerFormData>;
    profilePicture?: ICroppedImage | null;
    disabled?: boolean;
    setShowImageModal: (show: boolean) => void;
}

export const UploadProfileImageButton = ({
    register,
    errors,
    profilePicture,
    disabled,
    setShowImageModal
}: IUploadProfileImageButton) => {
    const {t} = useTranslation();

    return (
        <>
            <Form.Control
                as="button"
                size="lg"
                type="button"
                name="photo"
                className="btn-xl CreateWorker__upload-button btn-secondary-dark"
                onClick={() => setShowImageModal(true)}
                value={profilePicture?.base64}
                ref={register()}
                isInvalid={!!errors?.photo}
                disabled={disabled}
            >
                {t('actions.uploadProfilePicture', 'Upload Profile Image')}
                <FontAwesomeIcon className="CreateWorker__upload-button-icon" size="lg" icon={faPlus}/>
            </Form.Control>
            {(errors?.photo) && (
                <Form.Control.Feedback type="invalid" className="d-block">
                    {t('errors.photo.missing', 'Profile picture is required')}
                </Form.Control.Feedback>
            )}

        </>
    );
};
